<template>
  <v-fade-transition>
    <v-container v-if="show" class="features-bubble pa-0" @click.stop fluid :style="position">
      <v-layout>
        <v-flex v-for="(feature, index) in features" :key="index" class="pa-1" shrink>
          <v-feature-bubble-button :feature="feature" @click="addFeatureToProduct" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-fade-transition>
</template>

<script>
import { mapState } from "vuex";
import { TaggedFeatureError } from '@/store/ner/exceptions.js'

import VFeatureBubbleButton from "./FeatureBubbleButton";

export default {
  components: {
    VFeatureBubbleButton
  },
  computed: {
    ...mapState("ner", {
      features: state => state.features,
      selection: state => state.selection
    }),
    position() {
      if (!this.selection) return {};
      const top = `${this.selection.position.y + 20}px`;
      const left = `${this.selection.position.x}px`;
      return { top, left };
    },
    /**
     * Manage the visibility of this component.
     */
    show() {
      return !!this.selection;
    }
  },
  /**
   * Add the logic to handle outside of the bubble clicks to hide this component
   * and set the selection to null.
   */
  mounted() {
    document.addEventListener("click", this.selectionListener);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.selectionListener);
  },
  methods: {
    /**
     * Add the clicked feature to the product with the selection object.
     */
    addFeatureToProduct(feature) {
      this.$store.dispatch("ner/addTaggedFeatureToSelectedProduct", feature.id)
      .catch(err => {
        if (err instanceof TaggedFeatureError) {
          return this.$notify.error(`El producto ya tiene el atributo "${feature.name}"`)
        }

        this.$notify.error('Lo sentimos, tuvimos un error agregando el atributo.')
      });
      this.$store.commit("ner/setSelection", null);
    },
    /**
     * Set the selection object to null if there is no selection.
     * This will hide the component.
     * As this component stop the event propagation of the click it will not hide
     * the element before it process the selected feature.
     */
    selectionListener() {
      if (!document.getSelection().toString()) {
        this.$store.commit("ner/setSelection", null);
      }
    }
  }
};
</script>

<style scoped>
.features-bubble {
  position: fixed;
  z-index: 1;
}
</style>